import { render, staticRenderFns } from "./DirectTeam.vue?vue&type=template&id=40a3b273&scoped=true"
import script from "./DirectTeam.vue?vue&type=script&lang=js"
export * from "./DirectTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a3b273",
  null
  
)

export default component.exports